import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../_services/storage.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  if (!storageService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['private/home/dashboard']);
    return false;
  }
};
